/*
 *   File : connect-broker.js
 *   Author : https://evoqins.com
 *   Description : Added Stock brokers page
 *   Integrations : 
 *   Version : 1.0.0
*/

import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Modal } from "bootstrap";

// Components
import { TextButton } from "../../Component/Buttons";
import { ConnectBrokerModal } from "../../Component/Modal";
import Loader from "../../Component/Others/loader";
import { APIService } from "../../Service";
import { _checkBrokerStatus, _getProfile, _scrollToTop } from "../../Helper";

// Styles
import Styles from "../../Styles/Component/account.module.scss";

// Custom data
const BROKERS_LIST = [
    { "broker_name": "ACUMEN", "access_token_name": "access_token" },
    { "broker_name": "PRABHUDASLILLADHER", "access_token_name": "access_token" },
    { "broker_name": "ANGEL_BROKER", "access_token_name": "access_token" },
    { "broker_name": "63MOONSBROKER", "access_token_name": "access_token" },
    { "broker_name": "ACAGARWAL_UAT", "access_token_name": "access_token" },
    { "broker_name": "LATIN_MANHARLAL", "access_token_name": "access_token" },
    { "broker_name": "ABIRA", "access_token_name": "access_token" },

    { "broker_name": "NUVAMA", "access_token_name": "ordsrctkn" },
    { "broker_name": "IIFL", "access_token_name": "IIFLMarCookie" },
    { "broker_name": "PAYTM", "access_token_name": "requestToken" },
    { "broker_name": "5PAISA", "access_token_name": "RequestToken" },
    { "broker_name": "FYERS", "access_token_name": "auth_code" },
    { "broker_name": "MOTILAL_OSWAL", "access_token_name": "authtoken" },
    { "broker_name": "UPSTOX", "access_token_name": "code" },
    { "broker_name": "ZERODHA", "access_token_name": "request_token" },
    { "broker_name": "HDFC_SKY", "access_token_name": "access_token" },
    { "broker_name": "IIFL_CAPITAL", "access_token_name": "authcode" },
];

function ConnectBroker() {

    const USER_DATA = useSelector((store) => store.Reducer.USER_DATA);
    const { state } = useLocation();
    const navigate = useNavigate();
    const [dataLoading, setDataLoading] = useState(true);
    const [brokersList, setBrokersList] = useState([]);
    const [showBrokerConnectStatusModal, setShowBrokerConnectStatusModal] = useState(false);

    useEffect(() => {
        // Scroll the page to top
        _scrollToTop();

        // API call
        _getBrokersList();
    }, []);

    useEffect(() => {
        if (showBrokerConnectStatusModal) {
            const broker_modal = new Modal(document.getElementById('connect-modal'));
            broker_modal.show();
        }
    }, [showBrokerConnectStatusModal]);

    // handle connect broker
    const _handleConnectBroker = (selected_broker) => {

        if (selected_broker.url) {
            let broker_login_url = selected_broker.url;

            // 5PAISA , IIFL and NUVAMA - Appending callback url for this brokers
            if (selected_broker.broker_name === "5PAISA" || selected_broker.broker_name === "NUVAMA") {
                broker_login_url = broker_login_url + selected_broker.callback_url;
            };

            if (selected_broker.broker_name === "IIFL") {
                broker_login_url = `${broker_login_url}?VP=${selected_broker.callback_url}&UserKey=${selected_broker.api_key}`;
            };

            const broker_connect_window = window.open(broker_login_url, "_blank");
            let interval = setInterval(() => {
                try {
                    let current_url = broker_connect_window.location.href;
                    let url_data = current_url.split('?');
                    if (url_data.length !== 1) {
                        // Taking the token from the URL
                        let params = new URLSearchParams(url_data[1]);
                        let access_token_name = BROKERS_LIST.find(broker => broker.broker_name === selected_broker.broker_name).access_token_name;
                        let access_token = params.get(access_token_name);
                        clearInterval(interval);
                        broker_connect_window.close();
                        _validateBroker(selected_broker, access_token);
                    }
                } catch (error) {
                    console.log("Cross-origin access error. Waiting for the window to navigate...");
                }

                if (broker_connect_window.closed) {
                    clearInterval(interval);
                }

            }, 1000);
        }
    };

    // handle close status modal
    const _handleCloseStatusModal = () => {
        setShowBrokerConnectStatusModal(false);
    };

    // handle navigate to detail page 
    const _handleNavigate = () => {

        if (state && state.strategy_id) {
            navigate('/explore/strategy-detail', { state });
        } else {
            navigate("/explore");
        };
        setShowBrokerConnectStatusModal(false);
    };



    // ========== API CAllS ========== //
    // Get brokers list data
    const _getBrokersList = async () => {

        let url = "broker/list";
        let data = {
            "source": "WEB"
        };
        const response = await APIService(url, data);

        if (response.status_code === 200) {
            // Executable broker ordering
            setBrokersList(response.data);
        } else {
            setBrokersList("");
        }

        setDataLoading(false);
    };

    // Validate broker
    const _validateBroker = async (selected_broker, access_token) => {
        let url = "broker/validate";
        let data = {
            "user_id": USER_DATA.unique_identifier,
            "broker_id": selected_broker.broker_id,
            "access_token": access_token,
            "broker_name": selected_broker.broker_execution_name,
            "source": "WEB"
        };

        const response = await APIService(url, data);

        if (response.status_code === 200) {
            // Saving connected Broker info
            localStorage.setItem("indvestment_connected_broker", JSON.stringify(response.data));
            localStorage.setItem("indvestment_is_lumpsum_broker", state ? state.is_new_connection : false);
            setShowBrokerConnectStatusModal(true);

            // Update broker info
            _getProfile(USER_DATA.unique_identifier);

        } else {
            toast.dismiss();
            toast.error(response.message);
        }
    };




    return (

        <>
            {
                dataLoading ?
                    <Loader wrapperClassName="min-vh-100 margin-150px-top" />
                    :
                    <div className={`${Styles.connect_broker_card} px-2 px-sm-3 py-4  h-100 mb-4 min-vh-100`}>
                        <div className="col col-sm-10 col-md-7 col-lg-6 col-xl-5">
                            <TextButton name="Connect to Broker"
                                icon={true}
                                type={2}
                                labelClass="e-font-16-res"
                                onPress={() => navigate(-1)} />
                            <p className="px-2 mt-3 margin-20px-bottom e-text-chinese-black e-alt-font-lato e-font-weight-400 e-font-14 line-height-22px">
                                Easily link your account to top brokers for seamless transactions.
                                This integration ensures secure management of your investments.
                            </p>
                            <div className="row row-cols-3 row-gap-3 ps-2 gx-3">
                                {
                                    brokersList.map((broker, key) => (
                                        <div className="col" key={key}>
                                            <div className={`${Styles.gradient_border} border-radius-8 h-100 cursor-pointer`}
                                                onClick={() => _handleConnectBroker(broker)}>
                                                <div key={key}
                                                    className={"e-padding-8px-tb-12px-lr-res h-100 bg-white d-flex flex-column align-items-center padding-18px-all border-radius-8"}>
                                                    <img src={broker.broker_symbol_short}
                                                        alt={"broker-brand-logo"}
                                                        className={`${Styles.broker_logo} ${broker.broker_symbol_short ? "" : "invisible"} w-36px-res w-48px mb-2 object-fit-contain`} />
                                                    <span className="e-font-12-res e-text-chinese-black text-wrap-res text-nowrap text-center e-alt-font-lato e-font-weight-400 e-font-14">
                                                        {broker.broker_execution_name}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
            }


            {/* Broker connect success modal */}
            {
                showBrokerConnectStatusModal &&
                <ConnectBrokerModal
                    type={2}
                    buttonTittle={state && state.strategy_id ? "Resume Investing" : ""}
                    handleClose={_handleCloseStatusModal}
                    handleSuccess={_handleNavigate} />
            }
        </>
    )
}

export default ConnectBroker;